/* What an organisation may open, and what it may change.
 *
 * Two different answers, and the difference is the product's promise:
 *
 *  * never bought  → say what it is and how to get it
 *  * lapsed        → everything is here and readable; nothing can be changed
 *
 * An ERP that hides a tenant's own ledger because a card failed is holding a
 * business hostage over a payment problem. So lapsing takes away the buttons
 * and nothing else.
 */
import type { ReactNode } from 'react'
import { NotEntitled } from '@jackdesk/shell'
import index from './doctypes.generated.json'
import { areaFor, canWriteIn, useModules } from './modules'
import { labelFor } from './nav'

function moduleOf(doctype: string): string | undefined {
  return index.find((d) => d.n === doctype)?.m
}

export function Entitled({ doctype, children, onSeeStore }: {
  doctype: string
  children: (readOnly: boolean) => ReactNode
  onSeeStore?: () => void
}) {
  const modules = useModules()
  const module = moduleOf(doctype)
  const area = areaFor(modules, module)

  if (area?.state === 'off') {
    return (
      <div className="page">
        <NotEntitled module={area.label} onSeeStore={onSeeStore} />
        <p className="muted small" style={{ maxWidth: '58ch', marginTop: 8 }}>
          {area.what}. {labelFor(doctype)} is part of it.
        </p>
      </div>
    )
  }

  const readOnly = !canWriteIn(modules, module)
  return (
    <>
      {readOnly ? (
        <div className="page" style={{ paddingBottom: 0 }}>
          <div className="card card-pad small" role="status">
            <strong>{area?.label} has lapsed.</strong>{' '}
            {modules?.lapsed_means}
          </div>
        </div>
      ) : null}
      {children(readOnly)}
    </>
  )
}
